"use client";
import Image from "next/image";
import { useActionState, useRef } from "react";
import { toast } from "react-hot-toast";
import { sendEmailContactForm } from "../_lib/actions";
import { findErrors } from "../_lib/helper";
import ErrorMessages from "./ErrorMessages";
import SpanGold from "./SpanGold";
import SubmitButton from "./SubmitButton";

function ContactForm() {
  const initialState = { status: false, errors: [] };
  const ref = useRef(null);
  const [state, formAction] = useActionState(
    sendEmailContactForm,
    initialState,
  );
  const nameErrors = findErrors("name", state.errors);
  const surnameErrors = findErrors("surname", state.errors);
  const emailErrors = findErrors("email", state.errors);
  const messageErrors = findErrors("message", state.errors);
  const fetchErrors = findErrors("fetch", state.errors);

  state.status && toast.success("Vaše zpráva byla odeslána");

  // !state.status && toast.error(`Vyskytla se chyba v odesílání ${fetchErrors}`);

  const formItem =
    " appearance-none w-full md:w-5/6 my-1 border-1 border-slate-900 rounded-lg bg-slate-900 text-white hover:ring-2 hover:ring-teal focus:ring-teal";
  return (
    <div className="md:flex md:gap-20">
      {state.status && ref.current?.reset()}
      <form
        ref={ref}
        className="space-y-6 pt-10 text-white"
        action={formAction}
      >
        <h2 className="mb-8 text-5xl leading-[115%]">
          Napište mi, pomůžu Vám dostat se blíž k&nbsp;zajištěnému{" "}
          <SpanGold>životu.</SpanGold>
        </h2>
        <label className="block text-white">
          <span className="flex text-yellow-50">Jméno</span>
          <input type="text" name="name" className={formItem} />
          <ErrorMessages errors={nameErrors} />
        </label>
        <label className="block">
          <span className="block">Přijmení</span>
          <input type="text" name="surname" className={formItem} />
          <ErrorMessages errors={surnameErrors} />
        </label>
        <label className="block">
          <span className="block">E-mail</span>
          <input type="email" name="email" className={formItem} />
          <ErrorMessages errors={emailErrors} />
        </label>
        <label className="block">
          <span className="block">Vaše zpráva </span>
          <textarea name="message" className={formItem} rows={5} />
          <ErrorMessages errors={messageErrors} />
        </label>
        <SubmitButton look="gold" pendingLabel="odesílám...">
          Odeslat zprávu
        </SubmitButton>
        <ErrorMessages errors={fetchErrors} />
      </form>
      <div className="flex flex-col items-center justify-center">
        <div className="relative mt-12 h-[28rem] w-[20rem] md:mt-28 md:h-[40rem] md:w-[38rem]">
          <Image
            src="/MK_osobne.png"
            fill
            alt="Matej Král osobní foto"
            className="object-contain"
            sizes="(max-width: 750px) 20rem, 36rem"
            placeholder="empty"
          />
          <div className="absolute -top-[60px] right-0 h-[5.5rem] w-[5.6rem] md:-left-12 md:top-[34rem] md:h-[8.5rem] md:w-[8.75rem]">
            {/* <DecorRectCircle w={90} h={93} /> */}
            <Image
              fill
              src="/rect-circle.svg"
              alt=""
              className="object-contain"
              placeholder="empty"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
// 532x743
//    width={393}, height={558}
export default ContactForm;
